// Marquoir : appels d'achat toujours à portée (demande : « mettre les CTA plus en avant pour acheter le bijou »).
// - Choix mémorisés : mq:lettres { i1, i2 } et mq:finition { finition } (ouverture, abécédaire, fiche) sont gardés pour
//   la session (sessionStorage) et reportés dans l'adresse de chaque lien [data-mq-lien-composer] (?i1&i2&finition).
// - <mq-barre-achat> (snippet barre-achat, moins de 990 px) : « Composer mon collier · 49,90 € → » en bas de l'écran,
//   au pouce. Elle s'efface quand un autre appel « Composer » principal est lisible à l'écran (ouverture Pl. 01 et 03,
//   abécédaire, délai, appel final), quand un champ a le focus (clavier ouvert) et pendant le menu. Avec des lettres
//   choisies, elle dit « Composer avec J et M ».
// - <mq-barre-panier> (fiche produit) : « Ajouter au panier · 49,90 € » reste en bas tant que le bouton de la fiche
//   n'est pas à l'écran. C'est un vrai bouton d'envoi du même formulaire (attribut form) : mêmes contrôles (lettre
//   manquante : message et focus sur le groupe), même ajout. Il reprend l'état du bouton de la fiche (envoi en cours,
//   « Ajouté ») et, sur ordinateur, le récapitulatif « Aperçu : J puis M, finition dorée… ». Elle se retire dès que
//   le pied de page paraît : elle ne masque jamais le bas de la page.
// Mouvement réduit : apparition sans glissement (CSS).

const CLE = 'mq-choix';
const ok = (l) => typeof l === 'string' && /^[A-Za-z]$/.test(l);

function lireChoix() {
  try {
    const v = JSON.parse(window.sessionStorage.getItem(CLE) || '{}');
    return v && typeof v === 'object' ? v : {};
  } catch (e) {
    return {};
  }
}
function ecrireChoix(choix) {
  try { window.sessionStorage.setItem(CLE, JSON.stringify(choix)); } catch (e) { /* stockage indisponible */ }
}

const choix = lireChoix();

function urlAvecChoix(base) {
  const params = new URLSearchParams();
  if (ok(choix.i1) && ok(choix.i2)) { params.set('i1', choix.i1); params.set('i2', choix.i2); }
  if (choix.finition === 'doree' || choix.finition === 'argentee') params.set('finition', choix.finition);
  const q = params.toString();
  return q ? `${base}${base.includes('?') ? '&' : '?'}${q}` : base;
}

function majLiens(racine = document) {
  racine.querySelectorAll('[data-mq-lien-composer]').forEach((a) => {
    if (!a.dataset.mqBase) a.dataset.mqBase = a.getAttribute('href') || '';
    a.setAttribute('href', urlAvecChoix(a.dataset.mqBase));
  });
  document.querySelectorAll('mq-barre-achat').forEach((b) => { if (typeof b.majLibelle === 'function') b.majLibelle(); });
}

if (!window.__mqBarreAchat) {
  window.__mqBarreAchat = true;
  document.addEventListener('mq:lettres', (evt) => {
    const d = evt.detail || {};
    if (ok(d.i1) && ok(d.i2)) { choix.i1 = d.i1.toUpperCase(); choix.i2 = d.i2.toUpperCase(); }
    else { delete choix.i1; delete choix.i2; }
    ecrireChoix(choix);
    majLiens();
  });
  document.addEventListener('mq:finition', (evt) => {
    const f = evt.detail && evt.detail.finition;
    if (f === 'doree' || f === 'argentee') { choix.finition = f; ecrireChoix(choix); majLiens(); }
  });
  document.addEventListener('shopify:section:load', (evt) => majLiens(evt.target || document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => majLiens());
  else majLiens();
}

/** Lisible à l'écran : ni masqué (visibility, display), ni transparent (opacity 0 sur lui ou un parent). */
function lisible(el) {
  if (typeof el.checkVisibility === 'function') {
    if (!el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
  }
  for (let n = el; n && n !== document.body; n = n.parentElement) {
    const cs = getComputedStyle(n);
    if (cs.visibility === 'hidden' || Number(cs.opacity) < 0.5) return false;
  }
  return true;
}

/** Base commune : apparition selon un test, réévalué au défilement (une image sur deux au plus) et au calme. */
class BarreCollante extends HTMLElement {
  connectedCallback() {
    this.image = 0;
    this.minuteur = 0;
    this.planifier = () => {
      if (!this.image) this.image = requestAnimationFrame(() => { this.image = 0; this.maj(); });
      window.clearTimeout(this.minuteur);
      // les bascules des appels de l'ouverture durent 240 à 300 ms : on relit une fois le calme revenu
      this.minuteur = window.setTimeout(() => this.maj(), 340);
    };
    window.addEventListener('scroll', this.planifier, { passive: true });
    window.addEventListener('resize', this.planifier, { passive: true });
    document.addEventListener('focusin', this.planifier);
    document.addEventListener('focusout', this.planifier);
    this.demarrer();
    this.planifier();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.planifier);
    window.removeEventListener('resize', this.planifier);
    document.removeEventListener('focusin', this.planifier);
    document.removeEventListener('focusout', this.planifier);
    if (this.observateur) this.observateur.disconnect();
    window.cancelAnimationFrame(this.image);
    window.clearTimeout(this.minuteur);
  }

  champActif() {
    const a = document.activeElement;
    return Boolean(a && a.matches && a.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]'));
  }

  afficher(oui) {
    // tant que l'observateur n'a pas fait son premier relevé, rien ne paraît (pas d'éclair au chargement)
    if (!this.pret) oui = false;
    if (oui === this.hasAttribute('data-visible')) return;
    this.toggleAttribute('data-visible', oui);
    // invisible : hors de l'ordre de tabulation et des lecteurs d'écran
    this.inert = !oui;
  }
}

class MqBarreAchat extends BarreCollante {
  demarrer() {
    this.mobile = window.matchMedia('(max-width: 989px)');
    this.lien = this.querySelector('[data-mq-lien-composer]');
    this.libelle = this.querySelector('.mq-cta__libelle');
    this.libelleBase = this.libelle ? this.libelle.innerHTML : '';
    this.enVue = new Set();
    const hauteur = () => Math.round(this.getBoundingClientRect().height) || 72;
    this.observateur = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => { if (e.isIntersecting) this.enVue.add(e.target); else this.enVue.delete(e.target); });
      this.pret = true;
      this.planifier();
    }, { rootMargin: `0px 0px -${hauteur()}px 0px` });
    let suivis = 0;
    document.querySelectorAll('.mq-cta:not(.mq-cta--secondaire)').forEach((el) => {
      if (!this.contains(el) && !el.closest('dialog')) { this.observateur.observe(el); suivis += 1; }
    });
    if (!suivis) this.pret = true;
    this.mobile.addEventListener('change', this.planifier);
    this.majLibelle();
  }

  majLibelle() {
    if (!this.libelle) return;
    const modele = this.dataset.modeleAvec || '';
    if (ok(choix.i1) && ok(choix.i2) && modele) this.libelle.textContent = modele.replace('__I1__', choix.i1).replace('__I2__', choix.i2);
    else this.libelle.innerHTML = this.libelleBase;
  }

  maj() {
    if (!this.mobile || !this.mobile.matches) { this.afficher(false); return; }
    if (this.champActif() || document.querySelector('dialog[open]')) { this.afficher(false); return; }
    for (const el of this.enVue) if (lisible(el)) { this.afficher(false); return; }
    this.afficher(true);
  }
}

class MqBarrePanier extends BarreCollante {
  demarrer() {
    this.bouton = this.querySelector('[data-fp-barre-bouton]');
    this.cible = document.querySelector(this.dataset.cible || '[data-fp-ajouter]');
    this.recap = this.querySelector('[data-fp-barre-recap]');
    this.cibleVisible = false;
    this.piedVisible = false;
    const pied = document.querySelector('.mq-pied');
    if (pied && 'IntersectionObserver' in window) {
      this.observateurPied = new IntersectionObserver((entrees) => {
        entrees.forEach((e) => { this.piedVisible = e.isIntersecting; });
        this.planifier();
      });
      this.observateurPied.observe(pied);
    }
    if (this.cible) {
      this.observateur = new IntersectionObserver((entrees) => {
        entrees.forEach((e) => { this.cibleVisible = e.isIntersecting; });
        this.pret = true;
        this.planifier();
      }, { rootMargin: `0px 0px -${Math.round(this.getBoundingClientRect().height) || 72}px 0px` });
      this.observateur.observe(this.cible);
      // même état que le bouton de la fiche : libellé (Ajouter, Ajouté, Mettre à jour), prix, envoi en cours
      this.copie = new MutationObserver(() => this.copier());
      this.copie.observe(this.cible, { attributes: true, attributeFilter: ['aria-busy', 'class', 'aria-describedby'], childList: true, characterData: true, subtree: true });
      const recapSource = document.querySelector('[data-fp-recap]');
      if (recapSource && this.recap) {
        this.copieRecap = new MutationObserver(() => { this.recap.textContent = recapSource.textContent; });
        this.copieRecap.observe(recapSource, { childList: true, characterData: true, subtree: true });
        this.recap.textContent = recapSource.textContent;
      }
      this.copier();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.copie) this.copie.disconnect();
    if (this.observateurPied) this.observateurPied.disconnect();
    if (this.copieRecap) this.copieRecap.disconnect();
  }

  copier() {
    if (!this.bouton || !this.cible) return;
    const libelle = this.cible.querySelector('[data-fp-libelle]');
    const prix = this.cible.querySelector('[data-fp-prix]');
    const l = this.bouton.querySelector('[data-fp-barre-libelle]');
    const p = this.bouton.querySelector('[data-fp-barre-prix]');
    if (libelle && l && l.textContent !== libelle.textContent) l.textContent = libelle.textContent;
    if (prix && p && p.textContent !== prix.textContent) p.textContent = prix.textContent;
    const occupe = this.cible.getAttribute('aria-busy') === 'true';
    this.bouton.toggleAttribute('aria-busy', occupe);
    if (occupe) this.bouton.setAttribute('aria-busy', 'true');
    this.bouton.classList.toggle('fp-ajouter--ajoute', this.cible.classList.contains('fp-ajouter--ajoute'));
  }

  maj() {
    if (!this.cible) { this.afficher(false); return; }
    if (document.querySelector('dialog[open]')) { this.afficher(false); return; }
    this.afficher(!this.cibleVisible && !this.piedVisible);
  }
}

if (!customElements.get('mq-barre-achat')) customElements.define('mq-barre-achat', MqBarreAchat);
if (!customElements.get('mq-barre-panier')) customElements.define('mq-barre-panier', MqBarrePanier);
